import React from 'react';
import { compose } from 'redux';
import DashboardTemplate from 'components/templates/Dashboard';
import HeaderContainer from 'containers/HeaderContainer';
import PageQuery from 'hoc/PageQuery';
import PageView from 'hoc/PageView';
import PageTitle from 'hoc/PageTitle';
import ProtectedRoute, { DashboardsProtections } from 'hoc/ProtectedRoute';
import PageTheme from 'hoc/PageTheme';

import DetermineLayerContainer from 'containers/dashboards/DetermineLayerContainer';
import LayerThreeTVContainer from 'containers/dashboards/LayerThreeTVContainer';
import LayerTwoTVContainer from 'containers/dashboards/LayerTwoTVContainer';

import SideBarContainer from 'containers/SideBarContainer';
import TitleContainer from 'containers/TitleContainer';
import { SideBarObjects } from 'components/pages/config/DashboardSideBarObjects';
import showGGBrandingTheme from 'helpers/showGGBrandingTheme';
import { getQueryParamDefForObjectiveSwitcher } from 'helpers/objectiveSettings';
import { getQueryParamDefForRange } from 'helpers/range';

const TVDashboard = props => (
    <DashboardTemplate
        header={<HeaderContainer />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<TitleContainer entityId={parseInt(props.match.params.entityId, 10)} />}>

        <DetermineLayerContainer
            layerTwo={LayerTwoTVContainer}
            layerThree={LayerThreeTVContainer}
            {...props} />
    </DashboardTemplate>
);

export default compose(
    ProtectedRoute(DashboardsProtections),
    PageTitle({ pageTitle: 'Advanced TV' }),
    PageView({ page: 'Viewed Entity Advanced TV', trackEntity: true }),
    PageTheme({ themeDefaults: { 'whitelabel.showGGBranding': showGGBrandingTheme } }),
    PageQuery({
        params: {
            ...getQueryParamDefForRange(),
            ...getQueryParamDefForObjectiveSwitcher()
        },
        initialTruth: 'location',
    }),
)(TVDashboard);



// WEBPACK FOOTER //
// ./src/components/pages/dashboards/TV.js